import { InvoiceDto } from '@atlassian/commerce-ccp-gateway-client';
import { InvoiceWithLineItems } from '@atlassian/cssxp-types-billing';
import { base64ToBlob, getInvoicePdfData } from '@atlassian/temp-proxies';
import { AnalyticsTrackAction, AnalyticsTrackSubject, sendAnalyticsEvent } from '@atlassian/temp-analytics';
import FileSaver from 'file-saver';
import { transformInvoiceJsonData } from './transformer';

export const downloadCCPInvoiceAsJSON = (invoice: InvoiceDto, invoiceId: string, transactionAccountId: string) => {
  const jsonString = JSON.stringify(invoice, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  FileSaver.saveAs(blob, `${getFileName(invoice.number || '', 'json')}`);
  sendAnalyticsEvent(AnalyticsTrackAction.DOWNLOADED, AnalyticsTrackSubject.INVOICE_JSON, {
    transactionAccountId,
    invoiceId,
  });
};

export const downloadInvoiceAsJson = (invoice: InvoiceWithLineItems) => {
  const formattedJsonData = transformInvoiceJsonData(invoice);
  const jsonString = JSON.stringify(formattedJsonData, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  FileSaver.saveAs(blob, `${getFileName(invoice.invoiceNumber, 'json')}`);
};

export const downloadInvoiceAsPdf = async (invoice: InvoiceWithLineItems, transactionAccountId: string) => {
  const invoicePdfData = await getInvoicePdfData(invoice.id, transactionAccountId);
  if (invoicePdfData) {
    const blob = base64ToBlob(invoicePdfData);
    if (blob) FileSaver.saveAs(blob, `${getFileName(invoice.invoiceNumber, 'pdf')}`);
    sendAnalyticsEvent(AnalyticsTrackAction.DOWNLOADED, AnalyticsTrackSubject.INVOICE_PDF, {
      transactionAccountId,
      invoiceId: invoice.id,
    });
  }
};

const getFileName = (invoiceNumber: string | null, type: string): string => {
  return `invoice_${invoiceNumber}.${type}`;
};
